<template>
  <validation-provider
    :rules="validations"
    name="School"
    v-slot="{ errors }"
    slim
  >
    <v-autocomplete
      v-model="selectedSchool"
      :items="filteredSchools"
      :item-text="(item) => `${item.schoolName} - ${item.dbn}`"
      return-object
      @change="selectItem"
      placeholder="Start typing school name or DBN"
      :clearable="!readonly"
      :readonly="readonly"
      :loading="!readonly && schools.length === 0"
      :error-messages="errors"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.schoolName }}</v-list-item-title>
          <v-list-item-subtitle> {{ item.streetAddress }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template v-slot:no-data>
        <span v-if="readonly">No school</span>
        <span v-else-if="schools.length === 0">Loading Schools...</span>
        <v-card
          v-else
          flat
          dense
          color="grey lighten-2"
          @mousedown.prevent
          @click="goToNewSchool"
          text
          class="text-center text-decoration-underline"
          ><v-card-text
            ><v-btn small>Create New School</v-btn></v-card-text
          ></v-card
        >
      </template>
    </v-autocomplete>
  </validation-provider>
</template>


<script>
export default {
  props: ["school", "isSummerSemester", "clientId", "validations", "readonly"],
  data() {
    return {
      selectedSchool: this.school,
    };
  },
  computed: {
    filteredSchools() {
      if (this.isSummerSemester != null) {
        return this.$store.getters[
          "optionsModule/getFilteredSchoolsByIsSummerCamp"
        ](this.isSummerSemester ?? false);
      } else {
        return this.schools;
      }
    },
    schools() {
      return this.$store.state.optionsModule.schools;
    },
  },
  methods: {
    selectItem() {
      // if w/i ClientSchool page, then select the school. if w/i school lookup, then go to school form
      if (Boolean(this.clientId)) {
        this.$emit("selectSchool", this.selectedSchool?.schoolId);
      } else {
        this.$router.push({
          name: "SchoolDetails",
          params: { schoolId: this.selectedSchool?.schoolId },
        });
      }
    },
    goToNewSchool() {
      this.$router.push({
        name: "NewSchool",
        params: { clientId: this.clientId },
      });
    },
  },
};
</script>